var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 64,
    viewBox: "0 0 110 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7141 25.503L83.9449 27.1293L88.791 24.3414L83.9449 22.0182L80.7141 25.503Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.791 42.4626L79.0987 44.7858L76.791 46.4121L76.791 43.6242L79.791 42.4626Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.791 42.4626L63.4064 44.7858L60.8679 46.4121L59.7141 44.7858L61.791 42.4626Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4064 36.1899L45.1756 38.0485L40.3295 41.0687L37.0987 38.0485L39.4064 36.1899Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3295 15.7454L47.0218 23.1798L40.3295 25.503L37.0987 22.0182L40.3295 15.7454Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0987 1.80605L52.0987 4.82625L49.0987 6.45251L47.4833 4.3616L49.0987 1.80605Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0987 0.412108L81.4064 5.52322L80.7141 10.6343L74.4833 7.61413L76.0987 0.412108Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0218 23.1798L24.6372 27.1293L21.1756 27.1293L19.0987 23.1798L23.0218 23.1798Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56025 33.402L8.94486 35.4929L4.56025 38.0485L1.79102 36.1899L4.56025 33.402Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.424 53.4121L109.791 58.4121L109.091 63.4121L102.791 60.4576L104.424 53.4121Z",
    fill: "#E20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0767 55.4121L75.791 57.3169L70.991 60.4121L67.791 57.3169L70.0767 55.4121Z",
    fill: "#00A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 53.4121L41.791 54.9359L36.991 57.4121L33.791 54.9359L36.0767 53.4121Z",
    fill: "#00A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38682 20.4004L6.12401 26.4352L1.35547 23.2752L2.73534 19.0708L5.38682 20.4004Z",
    fill: "#00A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6478 20.3728L72.8066 28.0104L68.8665 31.482L66.5488 25.2331L71.6478 20.3728Z",
    fill: "#FAB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.242 31.482L104.791 34.4907L102.242 35.8794L100.851 34.4907L102.242 31.482Z",
    fill: "#FAB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8874 54.3946L57.0462 58.3291L54.4967 60.4121L52.4108 56.9405L55.8874 54.3946Z",
    fill: "#FAB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1087 44.4427L20.4264 47.22L18.1087 48.6086L15.791 47.22L18.1087 44.4427Z",
    fill: "#FAB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3535 7.4121L21.3535 9.72651L19.2676 10.4208L19.2676 8.80075L21.3535 7.4121Z",
    fill: "#FAB600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.30125c78af31be64d0a26cc9e830f39c.svg";
export { ForwardRef as ReactComponent };